export default __webpack_public_path__ + "static/media/whatsapp.ac98b1e7.png";